module.exports = __webpack_public_path__ + "static/media/home-service-slider-15.6f9c4399.jpg";